import React from "react";
import Link from "theme/components/atoms/Typography/Link";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import FormActions from "theme/components/molecules/Form/FormActions";
import StoreViewSelector from "theme/modules/User/StoreViewSelector";
import Svg from "theme/components/atoms/Icon/Svg";
import Button from "theme/components/atoms/Button/Button";

const messages = defineMessages({
  account: {
    id: "layouts.Header.Navigation.Menu.MenuNavigationMobile.account",
    defaultMessage: "My account",
  },
  wishlist: {
    id: "layouts.Header.Navigation.Menu.MenuNavigationMobile.wishlist",
    defaultMessage: "Wishlist",
  },
  products: {
    id: "layouts.Header.Navigation.Menu.MenuNavigationMobile.products",
    defaultMessage: "Our products",
  },
  enterpriseLink: {
    id: "layout.enterprise",
    defaultMessage: "Company",
  },
  close: {
    id: "layouts.Header.Navigation.Menu.MenuNavigationMobile.close",
    defaultMessage: "Close",
  },
});

const MobileMenuItem = ({ item, loading, handleCloseMenu }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleNavigation = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <div className="menu-nav-mobile__item">
      {item.children?.length ? (
        <div className="menu-nav-mobile__link-container">
          <Link
            to={item.path}
            className="menu-nav-mobile__link menu-nav-mobile__link-with-icon"
            onClick={handleNavigation}
            state={loading}
          >
            {item.name}
            <Svg
              type={isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
              className="menu-nav-mobile__icon"
            />
          </Link>
          <div
            className={`menu-nav-mobile__submenu ${
              isOpen ? "menu-nav-mobile__submenu--open" : ""
            }`}
          >
            <div className="menu-nav-mobile__item">
              <Link
                to={item.path}
                className="menu-nav-mobile__link"
                state={loading}
                onClick={handleCloseMenu}
              >
                <FormattedMessage
                  id="layouts.Header.Navigation.Menu.MenuNavigationMobile.allProducts"
                  defaultMessage="All products"
                />
              </Link>
            </div>
            {item.children.map((child) => (
              <MobileMenuItem
                key={child.path}
                item={child}
                loading={loading}
                handleCloseMenu={handleCloseMenu}
              />
            ))}
          </div>
        </div>
      ) : (
        <Link
          to={item.path}
          className="menu-nav-mobile__link"
          state={loading}
          onClick={handleCloseMenu}
        >
          {item.name}
        </Link>
      )}
    </div>
  );
};

const categoriesToList = (categories) =>
  categories.map((category) => ({
    path: category.path,
    name: category.name,
    children: category.children || [],
  }));

const MenuNavigation = ({
  data,
  wishlistFeature,
  enterpriseMenuLink,
  storeView,
  loading,
  handleCloseMenu,
}) => {
  const intl = useIntl();
  let mobileMainMenu = [];

  if (enterpriseMenuLink) {
    mobileMainMenu = [
      {
        path: enterpriseMenuLink,
        name: intl.formatMessage(messages.enterpriseLink),
        children: [],
      },
    ];
  }

  const categories = categoriesToList(data.navigationMenu);
  mobileMainMenu = [...mobileMainMenu, ...categories];

  return (
    <nav className="menu-nav-mobile">
      <div className="menu-nav-mobile__main-links">
        <FormActions>
          <div>
            <Button
              appearance="icon-header"
              onClick={handleCloseMenu}
              aria-label={intl.formatMessage(messages.close)}
            >
              <Svg type="close" />
            </Button>
          </div>
          <div className="stores">
            <StoreViewSelector storeView={storeView} />
          </div>
          {!wishlistFeature.loading && wishlistFeature.isFeatureActive ? (
            <Link
              to="/user/wishlist"
              state={loading}
              aria-label={intl.formatMessage(messages.wishlist)}
              buttonAppearance="icon-header"
              noSpan={true}
            >
              <Svg type="favorite" />
            </Link>
          ) : null}
        </FormActions>
      </div>

      <div className="menu-nav-mobile__list">
        {mobileMainMenu.map((item) => (
          <MobileMenuItem
            key={item.path}
            item={item}
            loading={loading}
            handleCloseMenu={handleCloseMenu}
          />
        ))}
      </div>
    </nav>
  );
};

export default MenuNavigation;
